/*
  Medcare theme analytics bridge.

  Install path:
  Add as an Online Store theme asset and include it in layout/theme.liquid:
  <script src="{{ 'medcare-theme-analytics-bridge.js' | asset_url }}" defer="defer"></script>

  This bridge publishes Medcare custom customer events. The Customer Events
  custom pixel translates them into GA4/Google Ads events through GTM.
*/

(function medcareThemeAnalyticsBridge() {
  const sent = new Set();

  function publishOnce(name, payload, key) {
    const eventKey = `${name}:${key || JSON.stringify(payload)}`;
    if (sent.has(eventKey)) return;
    sent.add(eventKey);

    if (window.Shopify?.analytics?.publish) {
      window.Shopify.analytics.publish(name, payload);
    }

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: name.replace("medcare:", ""),
      ...payload,
    });
  }

  function marketPayload() {
    const pathParts = window.location.pathname.split("/").filter(Boolean);
    const language = document.documentElement.lang || pathParts[0] || "en";
    return {
      language,
      page_location: window.location.href,
      page_path: window.location.pathname,
    };
  }

  function detectLeadSuccess() {
    const path = window.location.pathname;
    const isB2B = path.includes("/pages/wholesale-b2b-inquiry") || path.includes("/pages/b2b-information");
    const success =
      window.location.search.includes("contact_posted=true") ||
      window.location.hash === "#ContactForm" ||
      document.querySelector("#ContactForm .form-status.form__message") ||
      document.querySelector(".notice, .form-status, [data-form-success]");

    if (!success) return;

    const productHandle = new URLSearchParams(window.location.search).get("product") || undefined;
    publishOnce(
      "medcare:lead_success",
      {
        ...marketPayload(),
        lead_type: isB2B ? "b2b_wholesale" : "b2c_contact",
        form_location: path,
        product_handle: productHandle,
        value: isB2B ? 10 : 1,
      },
      `${path}:${productHandle || "general"}`,
    );
  }

  function publishPageIntent() {
    const path = window.location.pathname;
    if (path.includes("/pages/wholesale-b2b-inquiry") || path.includes("/pages/b2b-information")) {
      publishOnce(
        "medcare:qualified_product_interest",
        {
          ...marketPayload(),
          intent_type: "b2b_page_view",
          lead_type: "b2b_wholesale",
        },
        path,
      );
    } else if (path.includes("/pages/contact")) {
      publishOnce(
        "medcare:qualified_product_interest",
        {
          ...marketPayload(),
          intent_type: "contact_page_view",
          lead_type: "b2c_contact",
        },
        path,
      );
    }
  }

  document.addEventListener(
    "DOMContentLoaded",
    () => {
      publishPageIntent();
      detectLeadSuccess();
    },
    { once: true },
  );
})();
